<template>
  <div
    class="d-flex flex-column ma-0 pa-0"
    :style="`min-height:${minHeight}px`"
  >
    <span class="paragraph font-weight-bold blue-grey--text text--darken-3">{{
      title
    }}</span>
    <span
      v-if="paragraph"
      class="paragraph blue-grey--text text--darken-3 my-2"
      >{{ paragraph }}</span
    >
  </div>
</template>
<script>
export default {
  name: 'StatementPrint',
  props: {
    title: {
      type: String,
      required: true,
    },
    paragraph: {
      type: String,
      required: false,
    },
    minHeight: {
      type: Number,
      required: false,
    },
  },
}
</script>
